const messagesConfig = {
  label: "Member Message",
  resourceEndpoint: "messages",
  listMetadata: [
    "release_date",
    "active",
    "featured",
    "title",
    "description",
    "actions",
  ],
  keepListMetadataOrder: true,
  searchKeys: ["title"],
  detailsMetadata: [
    { name: "title", label: "Title" },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "web_description",
      label: "Description",
    },
    { name: "image_url", label: "Image URL" },
    { name: "release_date", label: "Release Date", format: "DD-MMM-yyyy" },
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      validations: [
        {
          type: "max",
          params: [40, "Maximum 40 Characters"],
        },
      ],
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: "active", label: "Active" },
    { name: "featured", label: "Featured" },
    { name: "tags", label: "Tags" },
    { name: "sections", label: "Sections" },
  ],
  formLayout: {
    columns: [
      ["title", "description", "image_url"],
      ["cta_type", "action_bar_text", "action_bar_text_enterprise", "action_bar_url", "enterprise_app", "cta", "release_date", "active", "featured", "tags"],
    ],
  },
  subTables: {
    sections: {
      label: {
        plural: "Sections",
        singular: "Section",
      },
      listMetadata: [
        { name: "id", label: "", hide: true, parser: (data) => data.id },
        {
          name: "sort_order",
          label: "Sort Order",
          parser: (data) => data.sort_order,
        },
        {
          name: "sub_description",
          label: "Description",
          parser: (data) => data.sub_description,
          ellipsis: true,
        },
        {
          name: "headline",
          label: "Headline",
          parser: (data) => data.headline,
        },
        { name: "title", label: "Section Title", parser: (data) => data.title },
      ],
      detailsMetadata: [
        { name: "sort_order", label: "Sort Order" },
        {
          name: "sub_description",
          label: "Description",
          validations: [
            { type: "required", params: ["Required"] },
            {
              type: "max",
              params: [20, "Maximum 20 Characters"],
            },
          ],
        },
        {
          name: "headline",
          label: "Headline",
          validations: [{ type: "max", params: [40, "Maximum 40 Characters"] }],
        },
        {
          name: "title",
          label: "Section Title",
          validations: [{ type: "max", params: [40, "Maximum 40 Characters"] }],
        },
        { name: "image_url", label: "Image URL" },
        { name: "text", label: "Section Text" },
        { name: "video_url", label: "Video URL" },
        { name: "question", label: "Question" },
        { name: "answer", label: "Answer" },
        { name: "media_metadata", label: "media_metadata", hidden: true },
      ],
    },
  },
};

export default messagesConfig;
